import { Node } from '../class';

export class FuncNode extends Node {
  public icon = 'code';
  public body: string;
  public readonly extraProperties = ['body'];
}
